<template>
    <div class="w-100" v-if="values">
        <div class="w-100 d-flex flex-column align-items-start" v-if="isEdit">
            <validation-observer
                :initialValues="{
                    payleap_login: values.gateway.payleap_login,
                    payleap_transaction_key: values.gateway.payleap_transaction_key,
                    payleap_vendor: values.gateway.payleap_vendor,
                }"
                ref="authnet_form"
                v-slot="{ meta, errors, setFieldValue }"
            >
                <validation-provider name="payleap_login" rules="required">
                    <form-input
                        label="Login ID:"
                        :error="errors['payleap_login']"
                        v-model="values.gateway.payleap_login"
                        @input="(val) => setFieldValue('payleap_login', val)"
                    />
                </validation-provider>
                <validation-provider rules="required" name="payleap_transaction_key">
                    <form-input
                        label="Transaction Key:"
                        type="password"
                        :error="errors['payleap_transaction_key']"
                        v-model="values.gateway.payleap_transaction_key"
                        @input="(val) => setFieldValue('payleap_transaction_key', val)"
                    />
                </validation-provider>
                <validation-provider rules="required" name="payleap_vendor">
                    <form-input
                        label="Vendor #:"
                        :error="errors['payleap_vendor']"
                        v-model="values.gateway.payleap_vendor"
                        @input="(val) => setFieldValue('payleap_vendor', val)"
                    />
                </validation-provider>
                <p>
                    The user name and password used to log in to the web interface and virtual terminal are not the same
                    credentials used to communicate with the API. In order to communicate with the API, your account
                    must allow API access and you must set up a separate API login ID and transaction key.
                </p>
                <div>
                    To learn more and signup for a merchant account that uses the PayLeap Gateway, please click
                    <a class="link" href="http://www.payleap.com/lp/lodgix271/" target="_blank">here</a>
                </div>
                <div class="submit-buttons-wrapper">
                    <b-button :disabled="!meta.valid" class="mr-2" variant="primary" @click="onSave">Save</b-button>
                    <b-button variant="default" @click="onCancel">Cancel</b-button>
                </div>
            </validation-observer>
        </div>
        <div v-else class="w-100">
            <div class="d-flex align-items-start mb-3">
                <div class="d-flex align-items-start mr-4">
                    <span>Login ID:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">
                        {{ values.gateway.payleap_login }}
                    </h3>
                </div>
                <div class="d-flex flex-column align-items-start">
                    <span>Transaction Key:</span>
                    <h3 class="text-primary cursor-pointer" @click="onEdit">**********</h3>
                </div>
                <div class="d-flex align-items-center mb-3">
                    <div class="d-flex flex-column align-items-start mr-4">
                        <span>Vendor #: </span>
                        <h3 class="text-primary cursor-pointer" @click="onEdit">
                            {{ values.gateway.payleap_vendor }}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormInput from '../../generic/form-input/form-input.vue';
    import FormCheckbox from '../../generic/form-checkbox/form-checkbox.vue';
    import { paymentComponentMixin } from './mixin';
    import { initial } from 'lodash';

    export default {
        name: 'PayleapEdit',
        components: { FormInput, FormCheckbox },
        mixins: [paymentComponentMixin],
    };
</script>

<style></style>
